<template>
  <div class="iosyinsi">
    <p class="title">隐私政策</p>
    <div class="block">
      <p class="two-title">我们非常重视您的隐私权。</p>
      <p class="common-p">
        广州心与潮信息科技有限公司（以下简称：心潮科技）
        致力于保护用户隐私权。本隐私权政策旨在向您说明，在使用我们的服务时，我们如何收集、存储、使用和管理这些信息。这些信息包括您向我们提供的个人信息或者我们通过我们网站或者移动应用终端收集到的相关信息。收集途径主要包括：移动设备上（如：苹果设备和安卓设备）提供的心潮科技应用程序产品(“我们的服务”)。 使用我们的服务就意味着您同意本政策，并同意根据本政策中规定的方式对您的数据（包括您的个人信息）进行收集和处理。如果您不同意本政策及未来修订版本的任何条款，请不要使用服务。
      </p>
      <p class="common-p">
        如对本政策或任何隐私权相关问题有任何疑问，请通过office@heartide.com与我们联系。
      </p>
    </div>
    <div class="block">
      <p class="two-title">我们可能收集的信息</p>
      <p class="common-p">
        为了向您提供更好的服务，我们将在法律允许的范围内和当且仅当您使用某些功能或者服务时，收集您的相关数据和信息。
      </p>
    </div>
    <div class="block">
      <p class="two-title">关于使用Health kit（中文名叫健康）数据说明</p>
      <p class="common-p">
        (1)当你需要使用Health kit（中文名叫健康，后续文案表述统一为Health kit）服务与我们产生数据链接时，首先需要你“打开小睡眠”-“我的”-“更多设置”-打开“健康中心”（默认关闭），此时，我们会明确告知你我们需要获取数据及简要功能说明，如你确认需要使用Health kit服务，请你点击“同意”，反之，你可以“拒绝”。<br/><br/>
        (2)当你同意我们与Health kit服务产生数据链接时，请你在“睡眠分析”类目中允许“小睡眠”睡眠数据（主要是卧床时间）写入到Health kit里，这将有利于你更好更方面管理睡眠，除此之外，我们承诺不会从Health kit获取其他无关数据。<br/><br/>
        (3)我们承诺你通过我们使用Health Kit的数据不会用于广告或应用其他商业化服务目的。同时请你也注意，你使用我们服务可能会存在广告，但是你使用Health Kit中的数据不会用于广告或应用其他商业化服务目的。<br/><br/>
        (4) 我们承诺不会向任何第三方展示、出售任何Health Kit获取数据，并且我们承诺建立严密技术措施确保你数据的安全。
      </p>
      <br/>
    </div>
    <div class="block">
      <p class="two-title">您使用服务时我们获取的信息</p>
      <p class="common-p"></p>
    </div>
    <div class="block">
      <p class="two-title">设备信息</p>
      <p class="common-p">
        当您在移动平台上使用任何心潮科技应用程序时，我们可能收集并记录某些信息，比如您的产品唯一身份标识（持续的／间断的）、硬件种类、介质访问控制（“MAC”）地址、国际移动电话设备识别码（“IMEI”）、您的操作系统（“OS”）版本、您设备的名称和您的位置（基于您的网络协议（“IP”）地址、SIM卡国家码、GPS）。这一信息有助于我们解决问题并了解总体用户使用倾向。
      </p>
      <p class="common-p">
        我们可能收集您的位置信息以向您提供正确的应用程序版本及更优质的服务。除本政策另有约定外，我们不会与任何第三方分享这一信息。如果您不再希望我们跟踪或使用这一信息，您可以在设备上关闭网络、GPS功能或者禁用我们获取您网络、GPS、设备信息权限。
      </p>
      <p class="common-p">
        此外，我们可能创建了唯一用户身份标识以跟踪您对我们服务的使用。此唯一用户身份标识与您的个人资料信息储存在一起，以便于了解您正在使用的心潮科技应用程序。
      </p>
    </div>
    <div class="block">
      <p class="two-title">使用日志</p>
      <p class="common-p">
        当您使用我们的服务，包括参与、生成、浏览与我们的服务相关的内容时，我们将会自动收集心潮科技应用内某些相关的日志信息，这些信息包括：(1)关于您的使用时间、使用频率和购买记录等细节；(2)设备统计信息、关键操作路径、错误日志、崩溃记录、语言和时区等。这些日志信息能够帮助我们更好的了解和改善我们的服务，并非用于识别任何特定的个人。
      </p>
    </div>
    <div class="block">
      <p class="two-title">广告</p>
      <p class="common-p">
        我们可能在服务中放映广告并且可能出于追踪广告目的收集并使用有关您的信息，例如您的设备标识符、MAC地址、IMEI、地理位置及IP地址。这些信息是为了用于创建内部用户编号以帮助我们更好地计数和追踪基于语言、地理位置和其他细节的广告。我们不会将这些信息出售给第三方。
      </p>
    </div>
    <div class="block">
      <p class="two-title">
        第三方收集的信息
      </p>
      <p class="common-p">
        我们提供的服务可能包括属于我们的服务供应商的第三方追踪工具。该第三方可能会在我们提供的服务中使用cookies、APIs（应用程序编程接口）及SDKs（软件程序开发包），由此代表我们收集并分析用户信息。第三方可能会访问诸如您的设备标识符、MAC（媒体访问控制）地址、IMEI（移动设备国际身份码）、区域（使用给定语言的特定地点）、地理位置信息及IP地址等信息，旨在实现在其各自隐私权政策下提供服务。我们的隐私权政策不会覆盖到第三方追踪工具的使用。我们没有权限访问或控制这些第三方。如果您想知道更多相应第三方信息，请发送电子邮件至office@heartide.com。
      </p>
    </div>
    <div class="block">
      <p class="two-title">
        我们如何使用信息
      </p>
      <p class="common-p">
        我们收集用户信息是以提升服务质量与用户体验为目的，为了实现这一目的，我们可能将您的信息用于：
      </p>
      <p class="two-title">(一) 创建帐号；</p>
      <p class="two-title">(二) 运营及改善我们的服务；</p>
      <p class="two-title">(三) 了解您与您的喜好，以提升您使用我们服务的体验与乐趣；</p>
      <p class="two-title">(四) 回复您的评论与问题，并提供客户服务；</p>
      <p class="two-title">(五) 提供及交付您要求的产品与服务；</p>
      <p class="two-title">(六) 发送与您相关的信息，包括确认、技术通告、更新、安全警告、支持及行政信息；</p>
      <p class="two-title">(七) 使您能与其他用户交流；</p>
      <p class="two-title">(八) 将其与我们从第三方获得的其他信息相联系或结合，以更好地了解您的喜好并为您提供更优质的服务;</p>
      <p class="two-title">(九) 为上述目的，在其他国家处理您的信息。</p>
      <p class="common-p">
        除非下列情形发生时，我们无权披露您的全部或部分信息：
      </p>
      <p class="two-title">(一) 为保护他人的人身或财产安全；</p>
      <p class="two-title">(二) 为防止或解决网络欺诈；</p>
      <p class="two-title">(三) 维护心潮科技的合法权利及权益;</p>
      <p class="two-title">(四) 实现“我们可能收集的信息”部分所述目的，前提条件为该等披露接收方应同等接受本政策约束并可以提供信息充分保护；</p>
      <p class="two-title">(五) 根据法律、法规的规定，或遵从政府部门、司法机关的要求；通常前述要求都是为了保护网络安全和保护我们、我们的用户和第三方的权利、财产和安全。</p>
    </div>
    <div class="block">
      <p class="two-title">信息安全性</p>
      <p class="common-p">我们使用合理措施，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术来保护您提供的个人信息。但请您理解（在互联网行业）即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
    </div>
    <div class="block">
      <p class="two-title">信息访问与控制</p>
      <p class="common-p">
        我们将采取一切合理适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障帐号安全。
      </p>
    </div>
    <div class="block">
      <p class="two-title">数据保留</p>
      <p class="common-p">
        受限于法律法规要求，我们将按照“我们如何使用信息”章节或者为您提供服务的时间范围内保留您的信息。如果您希望删除您的帐号或者要求我们不得再使用您的信息为您提供服务，请发送电子邮件至office@heartide.com。
      </p>
    </div>
    <div class="block">
      <p class="two-title">儿童信息</p>
      <p class="common-p">
        我们不会有意向13周岁以下的人群收集或请求个人信息。如果您低于13周岁，请不要向我们发送您的个人信息，包括您的名字、地址、电话号码或者邮箱地址。如果您认为我们可能有13周岁以下儿童任何信息时，请发送电子邮件至office@heartide.com。
      </p>
    </div>
    <div class="block">
      <p class="common-p" style="text-align: right">
        广州心与潮信息科技有限公司<br/>
        2020年7月15日
      </p>
    </div>
    <div class="block">
      <p class="two-title"></p>
      <p class="common-p"></p>
    </div>
    <div class="block">
      <p class="two-title"></p>
      <p class="common-p"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iosyinsi',
  mounted () {
    document.title = '隐私政策'
  }
}
</script>

<style lang="scss" scoped>
.iosyinsi {
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(18px);
  .title {
    font-size: px2html(16px);
    font-weight: 900;
    margin-bottom: px2html(28px);
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: left;
    margin-bottom: 7px;
  }
}
</style>
